import { render, staticRenderFns } from "./discord.vue?vue&type=template&id=3f38dbf9&scoped=true&"
var script = {}
import style0 from "./discord.vue?vue&type=style&index=0&id=3f38dbf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38dbf9",
  null
  
)

export default component.exports